var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "list-item",
    "class": ['padding-' + _vm.padding],
    attrs: {
      "data-growing-container": "",
      "data-growing-circle": ""
    }
  }, [_vm._t("default", function () {
    return [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "data-growing-container": "",
        "data-growing-circle": ""
      }
    }, [_c('div', {
      staticClass: "list-item-left"
    }, [_vm._t("left")], 2), _c('div', {
      staticClass: "list-item-right"
    }, [_vm._t("right")], 2), _vm._t("content")], 2)];
  }), _vm._t("extra")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };